import { BaseObject } from "@adgate/common/types/base-object.type";
import { Privilege } from "@adgate/modules/admin/types/privilege.type";

export class Role extends BaseObject
{
    showToOfficeAdmins!: boolean;
    privileges!: Privilege[];   

    constructor()
    {
        super();
        this.privileges = [];
    }
}